import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonPipesModule } from '../common/commonpipes.module';
import { NgxTranslateModule } from '../translate/translate.module';
import { fab, faFacebook, faYoutube, faDropbox, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas, faUser, faHeart, faList, faCartShopping, faRightLong, faBookmark, faArrowRight, faBuildingColumns, faStar, faStarHalfStroke, faCartPlus } from '@fortawesome/free-solid-svg-icons';

import { TemplateRoutingModule } from './template-routing.module';

@NgModule({
    declarations: [
    
  ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        NgxTranslateModule,
        RouterModule,
        CommonPipesModule,
        ReactiveFormsModule,
        TemplateRoutingModule,
        
        
    ] 
})
export class TemplateModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, far, fab);
        library.addIcons(
            faUser, faHeart, faList, faCartShopping, faFacebook, faYoutube, faDropbox, faTwitter, faRightLong,
            faBookmark, faArrowRight, faBuildingColumns, faStar, faStarHalfStroke, faCartPlus
        );
    }
}
